import { configureStore, createSlice } from '@reduxjs/toolkit';

// Slice pour la gestion des utilisateurs
const usersSlice = createSlice({
  name: 'users',
  initialState: {
    list: [],
    loading: false,
    error: null
  },
  reducers: {
    setUsers: (state, action) => {
      state.list = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  }
});

export const { setUsers, setLoading, setError } = usersSlice.actions;

const store = configureStore({
  reducer: {
    users: usersSlice.reducer
  },
});

export default store;
